import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ru from './ru/translation'
import en from './en/translation'
import { userLocaleAtom } from '../global/AtomsProvider'
import { getDefaultStore } from 'jotai'

const getUserLocale = () => {
  // probably doesn't work properly cause useLocaleAtom hasn't initialized yet
  let jotaiStore =  getDefaultStore()
  let locale = jotaiStore.get(userLocaleAtom)
  return locale
}

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    compatibilityJSON: 'v3',
    debug: false,
    lng: getUserLocale(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      ru: ru,
      en: en,
    }
  })

export default i18n